import {
  CREATE_SPECIALIST_PROVIDER,
  CREATE_SPECIALIST_PROVIDER_FAILURE,
  CREATE_SPECIALIST_PROVIDER_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const createSpecialistProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SPECIALIST_PROVIDER:
      return { ...state, loading: true };
    case CREATE_SPECIALIST_PROVIDER_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case CREATE_SPECIALIST_PROVIDER_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default createSpecialistProviderReducer;
